import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import Seo from '../components/Seo';
import ShareButtons from '../components/ShareButtons';
import CommentsSection from '../components/CommentsSection';
import { getReview } from '../lib/api';

function ReviewDetail() {
  const { slug } = useParams();
  const [review, setReview] = useState(null);
  const [related, setRelated] = useState([]);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    setNotFound(false);
    getReview(slug)
      .then((data) => {
        setReview(data.review);
        setRelated(data.related || []);
      })
      .catch(() => setNotFound(true));
  }, [slug]);

  if (notFound) {
    return (
      <div className="page page--narrow">
        <h1>Reseña no encontrada</h1>
        <Link to="/resenas">Volver a reseñas</Link>
      </div>
    );
  }

  if (!review) return null;

  return (
    <article className="page page--narrow">
      <Seo
        title={review.seo_title || review.title}
        description={review.meta_description || review.excerpt}
        image={review.social_image_url || review.cover_url}
      />

      {review.book_title && (
        <p className="content-card__category">
          <Link to={`/libros/${review.book_slug}`}>{review.book_title}</Link>
        </p>
      )}
      <h1>{review.title}</h1>
      {review.cover_url && <img src={review.cover_url} alt={review.title} style={{ borderRadius: 8, marginBottom: '1rem' }} />}

      {review.is_collaboration && (
        <p className="empty-state" style={{ borderStyle: 'solid' }}>
          Contenido en colaboración{review.collaboration_type ? ` (${review.collaboration_type})` : ''}.
          Las colaboraciones remuneradas compensan el tiempo de lectura, análisis, producción y difusión del
          contenido. La contratación de una colaboración no garantiza una valoración positiva.
        </p>
      )}

      <div className="rich-content" dangerouslySetInnerHTML={{ __html: review.content || '' }} />

      {(review.pros?.length > 0 || review.cons?.length > 0) && (
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem', marginTop: '2rem' }}>
          {review.pros?.length > 0 && (
            <div>
              <h3>Lo mejor</h3>
              <ul>{review.pros.map((item) => <li key={item}>{item}</li>)}</ul>
            </div>
          )}
          {review.cons?.length > 0 && (
            <div>
              <h3>Lo menos destacable</h3>
              <ul>{review.cons.map((item) => <li key={item}>{item}</li>)}</ul>
            </div>
          )}
        </div>
      )}

      <ShareButtons title={review.title} />

      {related.length > 0 && (
        <>
          <h3 style={{ marginTop: '3rem' }}>Reseñas relacionadas</h3>
          <div className="card-grid">
            {related.map((item) => (
              <Link key={item.id} to={`/resenas/${item.slug}`} className="content-card">
                {item.cover_url && <img src={item.cover_url} alt={item.title} />}
                <div className="content-card__body">
                  <h3 className="content-card__title">{item.title}</h3>
                </div>
              </Link>
            ))}
          </div>
        </>
      )}

      <CommentsSection contentType="review" contentId={review.id} />
    </article>
  );
}

export default ReviewDetail;
